export default __webpack_public_path__ + "static/media/IconDesc_AluminiumIngot.256.2642ca6d.png";